import { NO_VALUE } from './noValue.mjs';

const decorateCurrentMemberName = (name)=>`${name || NO_VALUE} (You)`;

export { decorateCurrentMemberName };
//# sourceMappingURL=decorateCurrentMemberName.mjs.map
